import React from "react";
import cntl from "cntl";
import {
  ADMIN_PATH,
  DEFAULT_TAB,
  MY_PROFILE,
  PAGES,
} from "../../../../constants";
import Tenants from "../Tenants";

const userAvatarDropdownMenuItemCN = cntl`
  w-full
  text-gray-450
  font-semibold
  text-sm
  tracking-wider
  -mt-1.5
  min-w-full
`;

const headerDropdownMenuItemCN = cntl`
  w-full
  text-gray-450
  font-medium
  text-xs
  tracking-wider
  min-w-full
`;

const returnList = ({
  isRegistered,
  selectDropdownItem,
  getActiveTab,
  onLogout,
  history,
  currentUser,
}) => {
  const items = [];

  if ((currentUser?.isAdmin || currentUser?.isSuperAdmin) && isRegistered) {
    items.push({
      title: "Account & Admin",
      className: userAvatarDropdownMenuItemCN,
      hoverColorCN: "text-green-400",
      onClick: selectDropdownItem(() =>
        history.push(
          `${ADMIN_PATH}?tab=${
            getActiveTab({
              page: PAGES.ACCOUNTANDADMIN,
            }) || DEFAULT_TAB(PAGES.ACCOUNTANDADMIN)
          }`
        )
      ),
    });
  }

  if (isRegistered) {
    items.push(
      {
        title: "My Profile",
        className: userAvatarDropdownMenuItemCN,
        hoverColorCN: "text-green-400",
        onClick: selectDropdownItem(() =>
          history.push(`${MY_PROFILE}?tab=${DEFAULT_TAB(PAGES.MYPROFILE)}`)
        ),
      },
      {
        title: "divider1",
        type: "divider",
        className: "border-gray-200",
      },
      {
        title: "TENANT",
        type: "header",
        className: `${headerDropdownMenuItemCN}`,
        wrapperClassName: "bg-backgroundGrey",
        onClick: () => {},
        options: <Tenants />,
      },
      {
        title: "divider2",
        type: "divider",
        className: "border-gray-200 mb-2",
      }
    );
  }

  items.push({
    title: "Log Out",
    className: userAvatarDropdownMenuItemCN,
    hoverColorCN: "text-green-400",
    onClick: onLogout,
  });

  return items;
};

export default returnList;
